import { PvdConfigApi } from '../../generated-client/apis';
import type {
  PvdConfigurationOnAzure,
  AddPvdConfigRequest,
  UpdatePvdConfigRequest,
  DeletePvdConfigRequest,
} from '../../generated-client/models';
import { useApiStore } from '../stores/apiStore';

let pvdConfigApi: PvdConfigApi | null = null;
let lastConfig: unknown = null;

function getPvdConfigApi(): PvdConfigApi {
  const { apiConfig } = useApiStore.getState();
  if (pvdConfigApi === null || lastConfig !== apiConfig) {
    pvdConfigApi = new PvdConfigApi(apiConfig);
    lastConfig = apiConfig;
  }
  return pvdConfigApi;
}

export const addPvdConfiguration = async (
  configuration: AddPvdConfigRequest,
): Promise<PvdConfigurationOnAzure> => {
  const api = getPvdConfigApi();
  return await api.apiPvdConfigAddPvdConfigPost({
    addPvdConfigRequest: configuration,
  });
};

export const deletePvdConfiguration = async (
  request: DeletePvdConfigRequest,
): Promise<void> => {
  const api = getPvdConfigApi();
  return await api.apiPvdConfigDeletePvdConfigDelete({
    deletePvdConfigRequest: request,
  });
};

export const updatePvdConfiguration = async (
  configuration: UpdatePvdConfigRequest,
): Promise<PvdConfigurationOnAzure> => {
  const api = getPvdConfigApi();
  return await api.apiPvdConfigUpdatePvdConfigPut({
    updatePvdConfigRequest: configuration,
  });
};

export const getAllPvdConfigurations = async (
  orgCode: string,
): Promise<Array<PvdConfigurationOnAzure>> => {
  const api = getPvdConfigApi();
  return await api.apiPvdConfigGetAllByOrgCodeGet({ orgCode });
};

export const getPvdConfigurationByOrgCodeAndId = async (
  orgCode: string,
  configId: string,
): Promise<PvdConfigurationOnAzure> => {
  const api = getPvdConfigApi();
  return await api.apiPvdConfigGetByOrgCodeAndIdGet({ orgCode, configId });
};
